/**
 *
 * topic state selectors
 *
 */

import { createSelector } from 'reselect';
import _get from 'lodash/get';

const selectTopic = (state) => state.topic;

const makeSelectTopicTitle = () =>
    createSelector(
        selectTopic,
        (topicState) => _get(topicState, 'data.title')
    );

const makeSelectTopicId = () =>
    createSelector(
        selectTopic,
        (topicState) => _get(topicState, 'data.id')
    );

const makeSelectTopicData = () =>
    createSelector(
        selectTopic,
        (topicState) => _get(topicState, 'data')
    );

export {
    selectTopic,
    makeSelectTopicTitle,
    makeSelectTopicId,
    makeSelectTopicData,
};
